import React, { useState, useEffect } from "react";
import ERC721 from "../../contracts/ERC721.json";
import CustomCollection from "../../contracts/CustomCollection.json";
import Clock from "../components/Clock";
import { createGlobalStyle } from 'styled-components';
import { useMoralisCloudFunction, useMoralis, useMoralisFile, useNewMoralisObject } from 'react-moralis';
import Identicon from 'identicon.js';
import IERC20 from "../../contracts/ERC20.json";
import StepsMint from "../components/StepsMint";
import StepsMintAndList from "../components/StepsMintAndList";
import StepsLazyMint from "../components/StepsLazyMint";
import StepsLazyMintAndList from "../components/StepsLazyMintAndList";

import SharedStorefront from "../../contracts/SharedStorefront.json";
import PulseVerseExchange from "../../contracts/PulseVerseExchange.json";
import TransferManagerERC721 from "../../contracts/TransferManagerERC721.json";
import TransferManagerERC1155 from "../../contracts/TransferManagerERC1155.json";
import StrategyStandardSaleForFixedPrice from "../../contracts/StrategyStandardSaleForFixedPrice.json";
import WETH9 from "../../contracts/WETH9.json";

import UserCollection from "../components/UserCollection"
import WrongNetwork from "../components/WrongNetwork";
import SuccessfulCreation from "../components/SuccessfulCreation"
import styled from "styled-components";
import tokens from "../../tokens.json";
import nameTokens from "../../nameTokens.json";

const Outer = styled.div`
`;
const regExp = /[a-z]/i;

const Createpage = (props) => {
  
  const dark = props.theme;
  const GlobalStyles = createGlobalStyle`
  header#myHeader.navbar.white {
    background: #fff;
  }
  .mr40{
    margin-right: 40px;
  }
  .mr15{
    margin-right: 15px;
  }
  .btn2{
    background: #f6f6f6;
    color: #EA14BD !important;
  }
  @media only screen and (max-width: 1199px) {
    .navbar .menu-line, .navbar .menu-line1, .navbar .menu-line2{
      background: #111;
    }
    .item-dropdown .dropdown a{
      color: #111 !important;
    }
  }
  
  h1, h2, h4, h3, h5, h6, .h1_big, .h1, .h2, .h3, .h4, .h5, .h6, span, p, a, input {
    color: ${dark === 'true' ? "#121212" : "white"};
  }
  .form-control, textarea, .dropbtn {
    color: ${dark === 'true' ? "#202225" : "white"};
    background: ${dark === 'true' ? "white" : "#202225"};
  }
  .dropdown-content {
    color: black;
    background: #F1F1F1;
  }
  .maincheckout {
		background: ${dark === 'true' ? "white" : "#121212"};
		color: ${dark === 'true' ? "#121212" : "white"};
	}
  .nft__item {
      border: ${dark === 'true' ? "solid 1px #ddd" : "solid 1px grey"};
  }
  `;

  const { isAuthenticated, user, logout } = useMoralis()
  const { save } = useNewMoralisObject('NFTCreated');
  const { save: makerSave  } = useNewMoralisObject('MakerAsk');
  const { save: unlockSave } = useNewMoralisObject('Unlockable');
  const { save: saveCollection } = useNewMoralisObject('Collection');
  const { save: saveCollections } = useNewMoralisObject('Collections');

  const signMakerOrder = async (collection, price, tokenId, amount, nonce, startTime, endTime, currency, strategy) => {
    const web3 = window.web3;
    const exchangeAddress = PulseVerseExchange.networks["941"].address;
      const msgParams = JSON.stringify({
        domain: {
          name: 'LooksRareExchange',
          version: '1',
          chainId: 941,
          verifyingContract: exchangeAddress,
        },
        message: {
          isOrderAsk: true,
          signer: user.get('ethAddress'),
          collection: collection,
          price: price,
          tokenId: tokenId,
          amount: amount,
          strategy: strategy,
          currency: currency,
          nonce: nonce,
          startTime: startTime,
          endTime: endTime,
          minPercentageToAsk: "8500",
          params: "0x",
        },
        primaryType: 'MakerOrder',
        types: {
          EIP712Domain: [
            { name: 'name', type: 'string' },
            { name: 'version', type: 'string' },
            { name: 'chainId', type: 'uint256' },
            { name: 'verifyingContract', type: 'address' }
          ],
          MakerOrder: [
            { name: 'isOrderAsk', type: 'bool' },
            { name: 'signer', type: 'address' },
            { name: 'collection', type: 'address' },
            { name: 'price', type: 'uint256' },
            { name: 'tokenId', type: 'uint256' },
            { name: 'amount', type: 'uint256' },
            { name: 'strategy', type: 'address' },
            { name: 'currency', type: 'address' },
            { name: 'nonce', type: 'uint256' },
            { name: 'startTime', type: 'uint256' },
            { name: 'endTime', type: 'uint256' },
            { name: 'minPercentageToAsk', type: 'uint256' },
            { name: 'params', type: 'bytes' },
          ],
        }
      });
    
      var from = user.get('ethAddress')
    
      var params = [from, msgParams]
      var method = 'eth_signTypedData_v4'
    
      await web3.currentProvider.sendAsync({
        method,
        params,
        from,
      }, async function (err, result) {
        if (err) {
          document.getElementById("error").innerHTML = err.message;
          console.error(err)
          document.getElementById("list").innerHTML = "Failed";
          return;
        }

        if (result.error) {
          document.getElementById("error").innerHTML = result.error.message;
          console.error(result.error)
          document.getElementById("list").innerHTML = "Failed";
          return;
        }

        console.log('TYPED SIGNED:' + JSON.stringify(result.result))

        var r = result.result.slice(0, 66)
        var s = '0x' + result.result.slice(66, 130)
        var v = '0x' + result.result.slice(130, 132)
        v = web3.utils.toDecimal(v);

        console.log(r)
        console.log(s)
        console.log(v)

        // await buyNowMarketplace.methods.listForBuyNow(user.get('ethAddress'), id, parsedPrice.toString(), 0, tokenContractAddress).send({from: user.get('ethAddress')});

        await makerSave({
          isOrderAsk: true,
          signer: user.get('ethAddress'),
          collection: collection,
          price: price,
          tokenId: tokenId,
          amount: amount,
          strategy: StrategyStandardSaleForFixedPrice.networks["941"].address,
          currency: WETH9.networks["941"].address,
          nonce: nonce,
          startTime: startTime,
          endTime: endTime,
          minPercentageToAsk: "8500",
          params: "0x",
          listing: "buy",
          r,
          s,
          v
        });

        setTokenId(tokenId)
        setNftCreated(true)
        document.getElementById("list").innerHTML = "Done";
    
      })
  }



  const [file, setFile] = useState([]);
  const [fileName, setFileName] = useState([]);
  const [fileType, setFileType] = useState([]);

  const [fileCollection, setFileCollection] = useState([]);
  const [fileNameCollection, setFileNameCollection] = useState([]);
  const [fileTypeCollection, setFileTypeCollection] = useState([]);

  const [fileCollectionBanner, setFileCollectionBanner] = useState([]);
  const [fileNameCollectionBanner, setFileNameCollectionBanner] = useState([]);
  const [fileTypeCollectionBanner, setFileTypeCollectionBanner] = useState([]);


  const [ownedCollections, setCollections] = useState([{"contractAddress": SharedStorefront.networks["941"].address, "name": "PulseVerse"}]);

  const [filePreview, setFilePreview] = useState([]);
  const [fileNamePreview, setFileNamePreview] = useState([]);
  const [fileTypePreview, setFileTypePreview] = useState([]);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [openCollection, setOpenCollection] = useState(false);

  const [activeCollection, setActiveCollection] = useState(SharedStorefront.networks["941"].address)

  const [isActive, setIsActive] = useState(false);
  const [isContent, setIsContent] = useState(false);
  const [setCompose, setIsComposing] = useState(false);
  const [isActiveSale, setIsActiveSale] = useState(false);
  const [listingType, setListingType] = useState(0);
  const [walletInit, setWalletInit] = useState(false);
  const [wrongNetwork, setWrongNetwork] = useState(false);
  const [nftCreated, setNftCreated] = useState(false);
  const [tokenId, setTokenId] = useState("");
  const [token, setToken] = useState("PLS");
  const [category, setCategory] = useState("Art");
  const [royalties, setRoyalties] = useState(1)
  const [compose, setComposing] = useState(1)
  const [mediaPreview, setMediaPreview] = useState(false);
  const [deadline, setDeadline] = useState(0);
  const [openCheckout, setOpenCheckout] = React.useState(false);
  const [properties, setProperties] = React.useState(1)
  const [listener, setListener] = React.useState(false);
  const [validity, setValidity] = React.useState("1 day");

  const { fetch: collectionFetch, data: collectionData, error: collectionError } = useMoralisCloudFunction("queryCollectionData",
    {"address": user && user.get('ethAddress')}
  );

  const { fetch: makerAskFetch, data: makerAskData, error: makerAskError } = useMoralisCloudFunction("queryMakerAsk",
    {"address": user && user.get('ethAddress')}
  );

  

  console.log(collectionData)
  console.log(collectionError)

  const signOut = () => {
    logout()
    if (document.getElementById("wrongnet")) {
      document.getElementById("wrongnet").style.display = "none";
    }
  }

  const {
    saveFile
  } = useMoralisFile();

  const { data } = useMoralisCloudFunction("queryUserData",
    user ? {"address": user.get('ethAddress')} : {"address": ""}
  );

  const web3 = window.web3;

  if (window.ethereum && !listener) {
    window.ethereum.on('chainChanged', function(networkId){
      if (networkId !== "0x3ac") {
        setWrongNetwork(true);
      } else {
        setWrongNetwork(false);      
      }
    })
    setListener(true);
  }

  const digitalAsset = new web3.eth.Contract(SharedStorefront.abi, SharedStorefront.networks["941"].address);
  // const transferManagerERC721 = new web3.eth.Contract(TransferManagerERC721.abi, TransferManagerERC721.networks["941"].address);
  // const transferManagerERC1155 = new web3.eth.Contract(TransferManagerERC1155.abi, TransferManagerERC1155.networks["941"].address);
    
  const isApprovedForAll = async (custom) => {
    let isApprovedForAll;
    if (user) {
      if (!custom) { 
        isApprovedForAll = await digitalAsset.methods.isApprovedForAll(user.get('ethAddress'), TransferManagerERC1155.networks["941"].address).call();
      } else {
        let customCollection = new web3.eth.Contract(CustomCollection.abi, activeCollection);
        isApprovedForAll = await customCollection.methods.isApprovedForAll(user.get('ethAddress'), TransferManagerERC721.networks["941"].address).call();
      }

    }
    return isApprovedForAll;
  }

  const approveForAll = async (custom) => {
    try {

      if (!custom) {
        document.getElementById("init").innerHTML = "In Progress...";
        await digitalAsset.methods.setApprovalForAll(TransferManagerERC1155.networks["941"].address, true).send({from: user.get('ethAddress')});
  
        
        document.getElementById("init").innerHTML = "Done";
        return true;
      } else {
        document.getElementById("init").innerHTML = "In Progress...";
        let customCollection = new web3.eth.Contract(CustomCollection.abi, activeCollection);
        await customCollection.methods.setApprovalForAll(TransferManagerERC721.networks["941"].address, true).send({from: user.get('ethAddress')});
        
        document.getElementById("init").innerHTML = "Done";
        return true;
      }


    } catch (error) {
      document.getElementById("error").innerHTML = error.message;
      console.error(error)
      return false;
    }

  }

  useEffect(() => {

    (async () => {
      let ownedCollectionsIter = [{"contractAddress": SharedStorefront.networks["941"].address, "name": "PulseVerse"}]

      if (collectionData && collectionData[0]) {
        let collect = collectionData[0].get('createdCollections')
        console.log(collect)
        if (collect) {
          for (let i = 0; i < collect.length; i++) {
            let ownable = new web3.eth.Contract(CustomCollection.abi, collect[i]);
            let owner = await ownable.methods.owner().call();
            console.log(owner)
            if (owner.toLowerCase() === user.get('ethAddress')) {
              let contract = new web3.eth.Contract(ERC721.abi, collect[i])
              let name = await contract.methods.name().call();
              ownedCollectionsIter.push({"name": name, "contractAddress": collect[i]})
            }
          }
        }
      }
      console.log(ownedCollections)
      
      if (ownedCollections.length === 1 && ownedCollectionsIter.length > 1) {
        setCollections(ownedCollectionsIter)
      }

      
      console.log(ownedCollectionsIter)
    })()

  })
  

  let profilePhoto;
  let dataJson = JSON.parse(JSON.stringify(data, null, 2));
  if (data !== null) {
    if (dataJson[0]) {
      profilePhoto = dataJson[0]["profilePhoto"];
    }
  }




  const itemNameChange = () => {
    document.getElementById('itemNamePreview').innerHTML = document.getElementById('item_title').value;
  }

  const itemPriceChange = () => {
    document.getElementById('itemPricePreview').innerHTML = `${document.getElementById('item_price').value}`;
  }

  const itemBidChange = () => {
    document.getElementById('itemPricePreview').innerHTML = `${document.getElementById('item_price_bid').value}`;
  }

  const bidOnChange = (e) => {
    setDeadline(e.target.value);
    console.log(deadline)
  }
  

  const listToken = async (contractAddress, tokenId) => {

    let approvedForAll = await isApprovedForAll(true);
    let success = false;
    if (!approvedForAll) {
      success = await approveForAll(true);
    }

    let check = await isApprovedForAll(true);
    setWalletInit(check);

    const blockNumber = await web3.eth.getBlockNumber();
    console.log(blockNumber)
    const timestamp = (await web3.eth.getBlock(blockNumber)).timestamp
    const secondsValid = parseInt(validity.split(" ")[0]) * 24 * 60 * 60;
    console.log(timestamp)
    console.log(secondsValid)

    if (success || check) {
      let tokenContractAddress = nameTokens[token][0]

      try {
        document.getElementById("list").innerHTML = "In Progress...";
        if (listingType === 0) {
          let price = document.getElementById("item_price").value;
          let parsedPrice = price * 10 ** tokens[tokenContractAddress][1];
          await signMakerOrder(contractAddress, parsedPrice.toString(), tokenId.toString(), "1", makerAskData.length.toString(), "0", (timestamp+secondsValid).toString(), tokenContractAddress, StrategyStandardSaleForFixedPrice.networks["941"].address);
        } else if (listingType === 1) {
          // Reserve Auction
        }
      } catch (error) {
        document.getElementById("error").innerHTML = error.message;
        console.error(error)
        document.getElementById("list").innerHTML = "Failed";        
      }
    }

  }

  const listItem = async (id, metadata, newNFT) => {
    let approvedForAll = await isApprovedForAll(false);
    let success = false;
    if (!approvedForAll) {
      success = await approveForAll(false);
    }

    let check = await isApprovedForAll(false);
    setWalletInit(check);

    const blockNumber = await web3.eth.getBlockNumber();
    console.log(blockNumber)
    const timestamp = (await web3.eth.getBlock(blockNumber)).timestamp
    const secondsValid = parseInt(validity.split(" ")[0]) * 24 * 60 * 60;
    console.log(timestamp)
    console.log(secondsValid)

    if (success || check) {
      let tokenContractAddress = nameTokens[token][0]

      if (metadata["editionSize"]) {
        // Lazy Mint
      } else {
        try {
          document.getElementById("list").innerHTML = "In Progress...";
          if (listingType === 0) {
            let price = document.getElementById("item_price").value;
            let parsedPrice = price * 10 ** tokens[tokenContractAddress][1];
            console.log(web3.utils.toWei(price, "ether"))
            let tokenId = id;
            let contractAddress = SharedStorefront.networks["941"].address;
            await signMakerOrder(contractAddress, parsedPrice.toString(), tokenId.toString(), "1", makerAskData.length.toString(), "0", (timestamp+secondsValid).toString(), tokenContractAddress, StrategyStandardSaleForFixedPrice.networks["941"].address);

          } else if (listingType === 1) {
            // Auction
          }

        } catch(error) {
          document.getElementById("error").innerHTML = error.message;
          console.error(error)
          document.getElementById("list").innerHTML = "Failed";
        } 
      }
    }
  }

  const createItem = async () => {

    let check;
    if (activeCollection === SharedStorefront.networks["941"].address) {
      check = await isApprovedForAll(false);
    } else {
      check = await isApprovedForAll(true);
    }

    setWalletInit(check);

      let title = document.getElementById("item_title").value;
      let description = document.getElementById("item_desc").value;
      let royaltiesPercentage = []
      let royaltiesReceivers = []

      let prcContractAddresses = []
      let prcContractAmounts = []
      let prcContracts = []

      let attributes = []
      let additionalMetadata;

      let error = false

      if (title === "") {
        error = true
        document.getElementById("error-create").innerHTML = "The NFT name has to be specified.";
      }
      
      if (!file[0]) {
        error = true
        document.getElementById("error-create").innerHTML = "No image or media uploaded.";
      }
      
      if (document.getElementById("content")) {
        additionalMetadata = document.getElementById("content").value
      }

      for (let i = 0; i < 3; i++) {
        if (document.getElementById(`royalties_receiver${i}`) && document.getElementById(`royalties_receiver${i}`).value !== "" && web3.utils.isAddress(document.getElementById(`royalties_receiver${i}`).value)) {
          royaltiesReceivers.push(document.getElementById(`royalties_receiver${i}`).value )
          if (document.getElementById(`item_royalties${i}`) && document.getElementById(`item_royalties${i}`).value !== "" && !regExp.test(document.getElementById(`item_royalties${i}`).value)) {
            royaltiesPercentage.push(document.getElementById(`item_royalties${i}`).value*"100000" )
          } else {
            royaltiesPercentage.push("0")
          }
        } else if (document.getElementById(`royalties_receiver${i}`) && document.getElementById(`royalties_receiver${i}`).value === "") {
          error = true
          document.getElementById("error-create").innerHTML = "Royalties receiver not specified.";
        } else if (document.getElementById(`royalties_receiver${i}`) && document.getElementById(`royalties_receiver${i}`).value !== "" && !web3.utils.isAddress(document.getElementById(`royalties_receiver${i}`).value)) {
          error = true
          document.getElementById("error-create").innerHTML = "Royalties receiver not valid. Check if the address is inputted correctly.";
        } else {
          royaltiesPercentage.push("0");
        }
      }

      for (let i = 0; i < 3; i++) {
        if (document.getElementById(`contract_address${i}`) && document.getElementById(`contract_address${i}`).value !== "") {
          if (prcContractAddresses.includes(document.getElementById(`contract_address${i}`).value)) {
            error = true
            document.getElementById("error-create").innerHTML = "Contract address duplicate found";
          } else {
            let contract = new web3.eth.Contract(IERC20.abi, document.getElementById(`contract_address${i}`).value)
            prcContractAddresses.push(document.getElementById(`contract_address${i}`).value )
            prcContracts.push(contract)
          }
        }
        if (document.getElementById(`contract_amount${i}`) && document.getElementById(`contract_amount${i}`).value !== "") {
          if (document.getElementById(`contract_amount${i}`).value <= "0") {
            error = true
            document.getElementById("error-create").innerHTML = "Contract amounts can't be 0 or less than 0";
          } else {
            prcContractAmounts.push(document.getElementById(`contract_amount${i}`).value )
          }

        }
      }

      for (let i = 0; i < 10; i++) {
        if (document.getElementById(`property_name${i}`) && document.getElementById(`property_name${i}`).value !== "") {
          if (document.getElementById(`property_value${i}`) && document.getElementById(`property_value${i}`).value !== "") {
            let parsedTrait = document.getElementById(`property_name${i}`).value.replaceAll('"', '\"'); /* eslint-disable-line */
            let parsedValue = document.getElementById(`property_value${i}`).value.replaceAll('"', '\"'); /* eslint-disable-line */
            attributes.push(
              {
                "trait_type": parsedTrait, 
                "value": parsedValue
              })
            
          }

        }

      }

      attributes = JSON.stringify(attributes)

      if (royaltiesPercentage.reduce((a, b) => parseInt(a) + parseInt(b), 0) > 1500000) {
        console.log("NO")
        document.getElementById("error-create").innerHTML = "Royalties can only add up to 15%";
        return;
      } else {
        if (error) {
          return;
        } else {
          await setOpenCheckout(true);
          document.getElementById("error-create").innerHTML = "";
          console.log("YES")
        }
      }

      await setOpenCheckout(true);

      const metadata = {
        "title": title,
        "description": description
      };

      let creator = user.get('ethAddress');
      let owner = user.get('ethAddress');
      let moralisUpload;
      let moralisUploadPreview;
      try {
      if (file[0]) {
        document.getElementById("upload").innerHTML = "In Progress...";
        console.log(fileName[0], file[0])
        moralisUpload = await saveFile(`${user.get('ethAddress')}.${fileType[0].split('/')[1]}`, file[0], {metadata, saveIPFS: true})
        console.log(moralisUpload)
        if (filePreview[0]) {
          moralisUploadPreview = await saveFile(`${user.get('ethAddress')}.${fileTypePreview[0].split('/')[1]}`, filePreview[0], {metadata, saveIPFS: true})          
        }

        console.log(moralisUploadPreview)

        let parsedDescription = description.replaceAll('"', '\\"').replaceAll("\n", "\\\\n");
        let parsedTitle = title.replaceAll('"', '\\"');

        let uri = await digitalAsset.methods.formatTokenURI(parsedDescription, parsedTitle, `ipfs://${moralisUpload._hash}`, filePreview[0] ? `ipfs://${moralisUploadPreview._hash}` : "", attributes.length > 0 ? attributes : "[]").call();
        console.log(uri)

        document.getElementById("upload").innerHTML = "Done";

        if (activeCollection === SharedStorefront.networks["941"].address) {
          if (!isActive) {
            let receipt;
  
              if (!setCompose) {
                document.getElementById("mint").innerHTML = "In Progress...";
                let totalSupply = await digitalAsset.methods.totalTokenSupply().call();
                console.log(totalSupply)
                receipt = await digitalAsset.methods.mint(1, totalSupply, uri, royaltiesReceivers[0], royaltiesPercentage[0]).send({from: creator});
              } else {
                // PRC20 contract in NFT
              }
  
              console.log(receipt)
              let editionId = receipt.events.TransferSingle.returnValues.id;
              let lazyMinted = false;
              let royaltiesPass = {"royaltyReceivers": royaltiesReceivers, "royalties": royaltiesPercentage}
              let editionAmount = 1;
              console.log(receipt.events.TransferSingle.returnValues.id)
              let newNFT = await save({moralisUpload, moralisUploadPreview, creator, owner, editionId, royaltiesPass, lazyMinted, metadata, uri, editionAmount, additionalMetadata});
              document.getElementById("mint").innerHTML = "Done";
              if (!isActiveSale) {
                await listItem(receipt.events.TransferSingle.returnValues.id, {}, newNFT)
              } else {
                setTokenId(receipt.events.TransferSingle.returnValues.id.toString())
                setNftCreated(true)
              }
  
  
          } else {
            // Lazy Mint NFT
          }          
        } else {
          document.getElementById("mint").innerHTML = "In Progress...";
          let customCollection = new web3.eth.Contract(CustomCollection.abi, activeCollection);
          let totalSupply = await customCollection.methods.totalSupply().call();
            let receipt = await customCollection.methods.mint(
              user.get('ethAddress'),
              totalSupply,
              uri,
              royaltiesReceivers[0],
              royaltiesPercentage[0]
            ).send({from: user.get('ethAddress')})
            document.getElementById("mint").innerHTML = "Done";
            if (additionalMetadata) {
              unlockSave({contractAddress: activeCollection, tokenId: receipt.events.Transfer.returnValues.tokenId, additionalMetadata})
            }
            if (!isActiveSale) {
              listToken(activeCollection, receipt.events.Transfer.returnValues.tokenId)
            } else {
              setTokenId(receipt.events.Transfer.returnValues.tokenId)
              setNftCreated(true)
            }

        }

      }

      } catch (error) {
            document.getElementById("error").innerHTML = error.message; 
            console.error(error)
            if (document.getElementById("prc20") && document.getElementById("prc20").innerHTML === "In Progress...") {
              document.getElementById("prc20").innerHTML = "Failed";      
            } else if (document.getElementById("mint").innerHTML === "In Progress...") {
              document.getElementById("mint").innerHTML = "Failed";            
            } else if (document.getElementById("upload") && document.getElementById("upload").innerHTML === "In Progress...") {
              document.getElementById("upload").innerHTML = "Failed";  
            }
      }



  }

  const createCollection = async () => {
    let description = document.getElementById("desc").value
    var _name = document.getElementById("name").value
    var _symbol = document.getElementById("ticker").value
    var customcollectionContract = new web3.eth.Contract(CustomCollection.abi);
    document.getElementById("createColl").innerHTML = "Creating..."
    customcollectionContract.deploy({
         data: '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',
         arguments: [
              _name,
              _symbol,
         ]
    })
    .send({
      from: user.get('ethAddress'),
      gas: '4700000',
    }, function(error, transactionHash){ console.log(transactionHash) })
    .on('error', function(error){ console.error(error) })
    .on('transactionHash', function(transactionHash){ console.log(transactionHash) })
    .on('receipt', function(receipt){
       console.log(receipt.contractAddress) // contains the new contract address
    })
    .on('confirmation', function(confirmationNumber, receipt){ console.log(receipt) })
    .then(async function(newContractInstance){
        // instance with the new contract address
        try {
          let profilePhoto = await saveFile(`${user.get('ethAddress')}.${fileTypeCollection[0].split('/')[1]}`, fileCollection[0], {saveIPFS: true})
          let profilePhotoBanner = await saveFile(`${user.get('ethAddress')}.${fileTypeCollectionBanner[0].split('/')[1]}`, fileCollectionBanner[0], {saveIPFS: true})
          let contractAddress = newContractInstance.options.address
          let ethAddress = user.get('ethAddress');
          saveCollection({description, profilePhoto, contractAddress, ethAddress, profilePhotoBanner, category, "name": _name}) // instance with the new contract address
          if (collectionData && collectionData[0]) {
            let collect = collectionData[0].get('createdCollections')
            collect.push(contractAddress)
            collectionData[0].save('createdCollections', collect)
  
            let collectUni = collectionData[0].get('collections')
            collectUni.push(contractAddress)
  
            collectionData[0].save('collections', collectUni)
            await collectionFetch()
  
          } else if (collectionData.length === 0) {
            let collections = [contractAddress]
            let createdCollections = [contractAddress]
            let userAddress = user.get('ethAddress')
            saveCollections({collections, createdCollections, userAddress})
            await collectionFetch()
          }
          document.getElementById("createColl").innerHTML = "Created"
        } catch (error) {
          console.error(error)
          document.getElementById("createColl").innerHTML = "Create"
        }

    });


 

  }

  const onChangeCollection = async (e) => {

    const file = e.target.files[0]
    const fileName = file.name
    const fileExtension = file.type

    await setFileNameCollection([fileName])
    await setFileTypeCollection([fileExtension])
    await setFileCollection([file])


    var image = document.getElementById('outputCollection');
    image.src = URL.createObjectURL(file);

  }

  const onChangeCollectionBanner = async (e) => {

    const file = e.target.files[0]
    const fileName = file.name
    const fileExtension = file.type

    await setFileNameCollectionBanner([fileName])
    await setFileTypeCollectionBanner([fileExtension])
    await setFileCollectionBanner([file])


    var image = document.getElementById('outputCollectionBanner');
    image.src = URL.createObjectURL(file);

  }


  const onChange = async (e) => {
    document.getElementById("file_name").style.display = "none";

    const file = e.target.files[0]
    console.log(file)
    const fileName = file.name
    const fileExtension = file.type
    console.log(fileExtension)
    await setFileName([fileName])
    await setFileType([fileExtension])
    await setFile([file])
    // var image = document.getElementById('output');
    // image.src = URL.createObjectURL(file);
    if (fileExtension.split("/")[0] === "video") {
      var video = document.getElementById('outputVideo');
      let video_prev = document.getElementById('video-prev');
      video.src = URL.createObjectURL(file);
      video_prev.src = URL.createObjectURL(file);
      setMediaPreview(true);
      document.getElementById("file_namePreview").style.display = "none";
    } else if (fileExtension.split("/")[0] === "audio") {
      var audio = document.getElementById('outputAudio');
      let video_prev = document.getElementById('video-prev');
      audio.src = URL.createObjectURL(file);
      video_prev.src = URL.createObjectURL(file);
      setMediaPreview(true);
      document.getElementById("file_namePreview").style.display = "none";
    } else {
      var image = document.getElementById('output');
      let image_prev = document.getElementById('nft-prev');
      image.src = URL.createObjectURL(file);
      image_prev.src = URL.createObjectURL(file);
      setMediaPreview(false);
    }

  }

  const onChangePreview = async (e) => {

    const file = e.target.files[0]
    const fileName = file.name
    const fileExtension = file.type

    await setFileNamePreview([fileName])
    await setFileTypePreview([fileExtension])
    await setFilePreview([file])

    if (fileType[0].split("/")[0] === "video") {
      let image_prev = document.getElementById('video-prev');
      let image = document.getElementById('outputPreview');
      image_prev.poster = URL.createObjectURL(file);
      image.src = URL.createObjectURL(file);
    } else if (fileType[0].split("/")[0] === "audio") {
      let image_prev = document.getElementById('video-prev');
      let image = document.getElementById('outputPreview');
      image_prev.poster = URL.createObjectURL(file);
      image.src = URL.createObjectURL(file);
    }

  }

  const handleCollection = (e) => {
    e.target.parentElement.classList.add("active");
    for (let i = 1; i < ownedCollections.length+1; i++) {
      if (parseInt(e.target.parentElement.id.split("coll")[1]) !== i) {
        document.getElementById(`coll${i}`).classList.remove("active")
      } else {
        setActiveCollection(e.target.parentElement.getAttribute('address'))
      }
    }

    console.log(activeCollection)

  }

  const handleShow = () =>{
      document.getElementById("tab_opt_1").classList.add("show");
      document.getElementById("tab_opt_1").classList.remove("hide");

      document.getElementById("tab_opt_3").classList.add("hide");
      document.getElementById("tab_opt_3").classList.remove("show");

      document.getElementById("tab_opt_2").classList.remove("show");
      document.getElementById("tab_opt_2").classList.add("hide");

      document.getElementById("btn1").classList.add("active");
      document.getElementById("btn2").classList.remove("active");
      // document.getElementById("btn3").classList.remove("active");
      setListingType(0);
      setDeadline(0);
  }
   const handleShow1 = ()=>{
      document.getElementById("tab_opt_2").classList.add("show");
      document.getElementById("tab_opt_2").classList.remove("hide");

      document.getElementById("tab_opt_1").classList.add("hide");
      document.getElementById("tab_opt_1").classList.remove("show");

      document.getElementById("tab_opt_3").classList.remove("show");
      document.getElementById("tab_opt_3").classList.add("hide");

      document.getElementById("btn1").classList.remove("active");
      document.getElementById("btn2").classList.add("active");
      // document.getElementById("btn3").classList.remove("active");
      setListingType(1);
      setDeadline(0);
  }
   const handleShow2 = ()=>{
      document.getElementById("tab_opt_3").classList.add("show");
      document.getElementById("tab_opt_3").classList.remove("hide");

      document.getElementById("tab_opt_1").classList.add("hide");
      document.getElementById("tab_opt_1").classList.remove("show");

      document.getElementById("tab_opt_2").classList.remove("show");
      document.getElementById("tab_opt_2").classList.add("hide");

      document.getElementById("btn1").classList.remove("active");
      document.getElementById("btn2").classList.remove("active");
      // document.getElementById("btn3").classList.add("active");
      if (document.getElementById('itemPricePreview')) {
        document.getElementById('itemPricePreview').innerHTML = ``;
      }

      setListingType(2);
      setDeadline(0);
  }

  const unlockClick = async ()=>{
    await setIsActive(true)
  }
  const unlockHide = async () => {
    await setIsActive(false)
  };

  const unlockContent = async ()=>{
    await setIsContent(true)
  }
  const hideContent = async () => {
    await setIsContent(false)
  };

  const unlockCompose = async ()=>{
    await setIsComposing(true)
  }
  const unlockHideCompose = async () => {
    await setIsComposing(false)
  };

  const unlockClickSale = async ()=>{
    await setIsActiveSale(true)
  }
  const unlockHideSale = async () => {
    await setIsActiveSale(false)
  };

    return (
      <div>
      <GlobalStyles/>


        <section className='container'>

        <h2 className='text-center'>Create Single Collectible</h2>
        <br/>
        <div className="row">
          <div className="col-lg-7 offset-lg-1 mb-5">

              <form id="form-create-item" className="form-border" action="#">
              
                  <div className="field-set">
                      <h5>Upload file</h5>

                      <div className="d-create-file">
                      <p id="file_name">PNG, JPG, GIF, MP3, WAV or MP4. Max 200mb.</p>
                      {file.length > 0 ? <p key="{index}">PNG, JPG, GIF, MP3, WAV or MP4. Max 200mb. <br/>{fileName}</p> : <></>}
                      {file.length > 0 ? (fileType[0].split("/")[0] === "image" ? <p><img id="output" alt="" style={{"max-width": "150px"}}/></p> : null) : null}
                      {file.length > 0 ? (fileType[0].split("/")[0] === "video" ? <video style={{width: "75%", height: "100%", "object-fit": "fill"}} id="outputVideo" controls>
                        Your browser does not support the video tag.
                      </video> : null) : null}
                      {file.length > 0 ? (fileType[0].split("/")[0] === "audio" ? <audio id="outputAudio" controls>
                        Your browser does not support the <code>audio</code> element.
                      </audio> : null) : null}
                      <div className='browse'>
                        <input type="button" id="get_file" className="btn-main" value="Browse"/>
                        <input id='upload_file' type="file" multiple onChange={onChange} />
                      </div>
                      
                  </div>
                      <div className="spacer-single"></div>
                  {mediaPreview && <><h5>Media preview</h5> <div className="d-create-file">
                      <p id="file_namePreview">PNG, JPG, GIF. Max 200mb.</p>
                      <p key="{index}">PNG, JPG, GIF. Max 200mb. <br/>{fileNamePreview}</p>
                      <p><img id="outputPreview" width="200" alt=""/></p>
                      <div className='browse'>
                        <input type="button" id="get_file" className="btn-main" value="Browse"/>
                        <input id='upload_file' type="file" multiple onChange={onChangePreview} />
                      </div>
                  </div></>}
                  
                      <div className="spacer-20"></div>

                      <div className="switch-with-title">
                        <h5><i className="fa fa- fa-unlock-alt id-color-2 mr10"></i>List Item</h5>
                          <div className="de-switch">
                            <input type="checkbox" id="switch-unlockSale" className="checkbox" defaultChecked/>
                              {isActiveSale ?(
                                <label htmlFor="switch-unlockSale" onClick={unlockHideSale}></label>
                              ) : (
                                <label htmlFor="switch-unlockSale" onClick={unlockClickSale}></label>
                              )}
                          </div>
                        <div className="clearfix"></div>
                      <p className="p-info pb-3">Put item up for sale.</p>
                      </div>
 
                      {!isActiveSale ?
                      <>
                      <h5>Select method</h5>
                                    <div className="de_tab tab_methods">
                                        <ul className="de_nav">
                                            <li id='btn1' className="active" onClick={handleShow}><span><p style={{marginBottom : "0px"}}><i className="fa fa-tag"></i></p><p style={{marginBottom : "0px"}}>Fixed price</p></span>
                                            </li>
                                            <li id='btn2'><span><p style={{marginBottom : "0px"}}><i className="fa fa-hourglass-1"></i></p><p style={{marginBottom : "0px"}}>Reserve auction <br/>(coming soon!)</p></span>
                                            </li>
                                        </ul>

                                        <div className="de_tab_content pt-3">
                                  
                                          <div id="tab_opt_1">
                                                <h5>Price</h5>
                                                <input onChange={itemPriceChange} type="text" name="item_price" id="item_price" className="form-control" placeholder={`enter price for one item (${token})`}/>
                                                <h5>Payment Token</h5>
                                                <div class="dropdown">
                                                  <input class="dropbtn" value={token}></input>
                                                  <div class="dropdown-content">
                                                    <button onClick={(e) => {e.preventDefault(); setToken("PLS")}} className="pToken">PLS <img width="25" src="./img/pulsechain-logo.png" alt=""></img></button>
                                                    <button onClick={(e) => {e.preventDefault(); setToken("HEX")}} className="pToken">HEX <img width="25" src="./img/hex-logo.png" alt=""></img></button>
                                                    <button onClick={(e) => {e.preventDefault(); setToken("PLSV")}} className="pToken" disabled>PLSV (COMING SOON)</button>
                                                  </div>
                                                </div>
                                                <div className="spacer-20"></div>
                                                <h5>Validity</h5>
                                                <div class="dropdown">
                                                  <input class="dropbtn" value={validity}></input>
                                                  <div class="dropdown-content" style={{width: "100%"}} >
                                                    <button style={{width: "100%"}} onClick={(e) => {e.preventDefault(); setValidity("1 day")}}>1 day</button>
                                                    <button style={{width: "100%"}} onClick={(e) => {e.preventDefault(); setValidity("3 days")}}>3 days</button>
                                                    <button style={{width: "100%"}} onClick={(e) => {e.preventDefault(); setValidity("7 days")}}>7 days</button>
                                                    <button style={{width: "100%"}} onClick={(e) => {e.preventDefault(); setValidity("14 days")}}>14 days</button>
                                                    <button style={{width: "100%"}} onClick={(e) => {e.preventDefault(); setValidity("90 days")}}>90 days</button>
                                                    <button style={{width: "100%"}} onClick={(e) => {e.preventDefault(); setValidity("180 days")}}>180 days</button>
                                                  </div>
                                                </div>
                                          </div>

                                            <div id="tab_opt_2" className='hide'>
                                                <h5>Minimum bid</h5>
                                                <input type="text" name="item_price_bid" id="item_price_bid" className="form-control" placeholder="enter minimum bid" onChange={itemBidChange}/>
                                                <h5>Payment Token</h5>
                                                <div class="dropdown">
                                                  <input class="dropbtn" value={token}></input>
                                                  <div class="dropdown-content">
                                                    <button onClick={(e) => {e.preventDefault(); setToken("PLS")}} className="pToken">PLS <img width="25" src="./img/pulsechain-logo.png" alt=""></img></button>
                                                    <button onClick={(e) => {e.preventDefault(); setToken("HEX")}} className="pToken">HEX <img width="25" src="./img/hex-logo.png" alt=""></img></button>
                                                    <button onClick={(e) => {e.preventDefault(); setToken("PLSV")}}  className="pToken" disabled>PLSV (COMING SOON)</button>
                                                  </div>
                                                </div>
                                                <div className="spacer-20"></div>

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <h5>Starting date</h5>
                                                        <input type="date" name="bid_starting_date" id="bid_starting_date" className="form-control" min="1997-01-01" onChange={bidOnChange}/>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h5>Expiration date</h5>
                                                        <input type="date" name="bid_expiration_date" id="bid_expiration_date" className="form-control" />
                                                    </div>
                                                </div>
                                            </div>

                                            <div id="tab_opt_3" className='hide'>
                                                <h5>Payment Token</h5>
                                                <div class="dropdown">
                                                  <input class="dropbtn" value={token}></input>
                                                  <div class="dropdown-content">
                                                    <button onClick={(e) => {e.preventDefault(); setToken("PLS")}}><p style={{marginBottom: "0px"}} className="pToken">PLS</p> <img width="25" src="./img/pulsechain-logo.png" alt=""></img></button>
                                                    <button onClick={(e) => {e.preventDefault(); setToken("HEX")}}><p style={{marginBottom: "0px"}} className="pToken">HEX</p> <img width="25" src="./img/hex-logo.png" alt=""></img></button>
                                                    <button onClick={(e) => {e.preventDefault(); setToken("PLSV")}} className="pToken" disabled><p style={{marginBottom: "0px"}}>PLSV (COMING SOON)</p></button>
                                                  </div>
                                                </div>
                                                <div className="spacer-20"></div>

                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <h5>Starting date</h5>
                                                        <input type="date" name="bid_starting_date" id="bid_starting_offer" className="form-control" min="1997-01-01" onChange={bidOnChange} />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>

                                    <div className="spacer-20"></div>
                                    <div className="spacer-single"></div>
                                    </>
                      : null}
                      <div className="de_tab tab_methods">
                      <h5>Choose Collection</h5>
                      <ul className="de_nav">
                          {ownedCollections.map((c, i) => {
                            return(<li id={`coll${i+1}`} className={c.contractAddress === activeCollection ? "active" : ""} address={c.contractAddress} onClick={handleCollection}><span><UserCollection small={true} address={c.contractAddress}/><p style={{marginBottom : "0px"}}>{c.name}</p></span>
                            </li>)                  
                          })}
                          <li id={`createCollection`} onClick={() => setOpenCollection(true)}><span style={localStorage.getItem('darkMode') === 'true' ? {"color": `black`} : {"color": `white`}}><p style={{marginBottom : "0px"}}><i  class="fa fa-plus-square"></i></p><p style={{marginBottom : "0px"}}>Create Collection</p></span>
                          </li>
                        </ul>
                      </div>
                      <div className="spacer-single"></div>
                      <h5>Name</h5>
                      <input onChange={itemNameChange} type="text" name="item_title" id="item_title" className="form-control" placeholder="e.g. 'Crypto Funk" />

                      <div className="spacer-10"></div>

                      <h5>Description</h5>
                      <textarea data-autoresize name="item_desc" id="item_desc" className="form-control" placeholder="e.g. 'This is very limited item'"></textarea>

                      <div className="spacer-10"></div>

                      <div className="spacer-10"></div>

                      <h5>Royalties</h5>
                      {/* {activeCollection === SharedStorefront.networks["941"].address && <div style={{"display": "flex"}}>
                        <button class="btn-main" onClick={(e) => {e.preventDefault(); royalties + 1 < 4 && setRoyalties(royalties+1)}}>+</button>
                        <button style={{marginLeft: "5px"}}class="btn-main" onClick={(e) => {e.preventDefault(); royalties - 1 > 0 && setRoyalties(royalties-1)}}>-</button>
                      </div>} */}
                      {[...Array(royalties)].map((e, i) => {
                        return(
                          <div>
                          <input type="text" name="item_royalties" id={`item_royalties${i}`} className="form-control" placeholder="suggested: 0, 10%, 20%, 30%. Maximum is 15%" />
                          <input type="text" name="item_royalties" id={`royalties_receiver${i}`} className="form-control" placeholder="0x00000...0000000" />
                          <div className="spacer-10"></div>
                        </div>
                      )})}

                      <div className="spacer-10"></div>
                      <div className="switch-with-title">
                          <h5><i className="fa fa- fa-unlock-alt id-color-2 mr10"></i>Unlockable Content</h5>
                          <div className="de-switch">
                          {<input type="checkbox" id="switch-unlockContent" className="checkbox"/>}
                            {isContent ?(
                            <label htmlFor="switch-unlockContent" onClick={hideContent}></label>
                            ) : (
                            <label htmlFor="switch-unlockContent" onClick={unlockContent}></label>
                            )}
                          </div>
                          <div className="clearfix"></div>
                          <p className="p-info pb-3">Set additional content for the buyer to receive once a sale or transfer is made.</p>
                      </div>

                      {isContent && <input className="form-control" id="content" placeholder="Unlockable content (a link to a product etc.)"/>}

                      <div className="spacer-10"></div>

                      <div className="switch-with-title">
                          <h5><i className="fa fa- fa-unlock-alt id-color-2 mr10"></i>Lazy Mint (coming soon)</h5>
                          <div className="de-switch">
                          {activeCollection === SharedStorefront.networks["941"].address ? <input type="checkbox" id="switch-unlock" className="checkbox" disabled/> : <input type="checkbox" id="switch-unlock" className="checkbox disabled" disabled/>}
                            
                            {isActive ?(
                            <label htmlFor="switch-unlock" onClick={null}></label>
                            ) : (
                            <label htmlFor="switch-unlock" onClick={null}></label>
                            )}
                          </div>
                          <div className="clearfix"></div>
                          <p className="p-info pb-3">NFT is not minted on chain until the sale.</p>
                      </div>

                      <div className="spacer-10"></div>

                      <div className="switch-with-title">
                          <h5><i className="fa fa- fa-unlock-alt id-color-2 mr10"></i>Compose PRC20 into NFT (coming soon)</h5>
                          <div className="de-switch">
                            {!isActive && activeCollection === SharedStorefront.networks["941"].address ? <input type="checkbox" id="switch-unlockCompose" className="checkbox" disabled/> : <input type="checkbox" id="switch-unlockCompose"className="checkbox disabled" disabled/>}
                            {setCompose ?(
                            <label htmlFor="switch-unlockCompose" onClick={null}></label>
                            ) : (
                            <label htmlFor="switch-unlockCompose" onClick={null}></label>
                            )}
                          </div>
                          <div className="clearfix"></div>
                          <p className="p-info pb-3">Attach any PRC20 to your newly created NFT.</p>
                      </div>

                      {setCompose && !isActive ? <><div style={{"display": "flex"}}>
                        <button class="btn-main" onClick={(e) => {e.preventDefault(); compose + 1 < 4 && setComposing(compose+1)}}>+</button>
                        <button style={{marginLeft: "5px"}}class="btn-main" onClick={(e) => {e.preventDefault(); compose - 1 > 0 && setComposing(compose-1)}}>-</button>
                      </div>
                      <br/>
                      {[...Array(compose)].map((e, i) => {
                        return(
                          <div>
                          <input type="text" name="prc20" id={`contract_address${i}`} className="form-control" placeholder="PRC20 contract address" />
                          <input type="text" name="prc20" id={`contract_amount${i}`} className="form-control" placeholder="PRC20 amount for all tokens in edition" />
                          <div className="spacer-10"></div>
                        </div>
                      )})}</> : null}

                      <div className="spacer-single"></div>
                      <span onClick={() => setShowAdvanced(!showAdvanced)} className="btn-main inline white lead" style={{fontSize: "20px", width: "100%", backgroundColor: "#E6E0FF"}}>Show advanced options</span>
                      <div className="spacer-single"></div>
                      {showAdvanced ? <div>
                        <h5>Properties</h5>
                        <div style={{"display": "flex"}}>
                        <button class="btn-main" onClick={(e) => {e.preventDefault(); properties + 1 < 10 && setProperties(properties+1)}}>+</button>
                        <button style={{marginLeft: "5px"}}class="btn-main" onClick={(e) => {e.preventDefault(); properties - 1 > 0 && setProperties(properties-1)}}>-</button>
                      </div>
                      <div className="spacer-10"></div>
                        <div>
                            {[...Array(properties)].map((e, i) => {
                            return(
                              <div>
                                <div style={{"display": "flex"}}>
                                  <input className="form-control" id={`property_name${i}`} placeholder="Property Name"/> 
                                  <input className="form-control" id={`property_value${i}`} placeholder="Property Value" style={{marginLeft: "5px"}}/>
                                </div>
                                <div className="spacer-2"></div>
                              </div>
                          )})}
                        </div>
                      </div> : null}
                      <div className="spacer-single"></div>
                      <input type="button" id="submit" className="btn-main" style={{fontSize: "16px"}} value="Create Item" onClick={createItem} />
                      <p id="error-create" style={{color: "red"}}></p>
                                            <div className="spacer-10"></div>
                  </div>
              </form>
          </div>

          <div className="col-lg-3 col-sm-6 col-xs-12 fixed-content">
          <GlobalStyles/>
                  <h5>Preview item</h5>
                  <div className="nft__item m-0">
                      <div className="author_list_pp">
                          <span>                                    
                              {profilePhoto ? <img className="lazy" src={`${profilePhoto.url}`} alt=""/> : user && <img src={`data:image/png;base64,${new Identicon(user.get('ethAddress'), 30).toString()}`} alt=""/>}
                          </span>
                      </div>
                      <div className="nft__item_wrap">
                        <Outer>
                          <span>
                            {file.length > 0 ? (fileType[0].split("/")[0] === "image" ? <p><img id="nft-prev" alt="" style={{"max-height": "250px"}}/></p> : null) : null}
                            {file.length > 0 ? (fileType[0].split("/")[0] === "video" || fileType[0].split("/")[0] === "audio" ? <video style={{width: "100%", height: "100%", "object-fit": "fill"}} width="320" height="240" id="video-prev" controls>
                              Your browser does not support the video tag.
                            </video> : null) : null}
                          </span>
                        </Outer> 
                      </div>
                      {listingType !== 0 ? <div className="de_countdown">
                          <Clock deadline={deadline} />
                      </div> : null}
                      <div className="nft__item_info">
                          <h4 id="itemNamePreview"></h4> {/* eslint-disable-line */}
                          {listingType !== 2 ? <div className="nft__item_price">
                          <span style={{marginLeft: "0px"}} id="itemPricePreview"></span> <span style={{marginLeft: "0px"}}>{token}</span><span id="itemRangePreview">1/1</span>
                          </div> : <div className="nft__item_price" style={{marginLeft: "0px"}}><span style={{marginLeft: "0px"}}>Open to offers: {token}</span><span id="itemRangePreview">1/1</span></div>}
                          <div className="nft__item_action">
                              {listingType === 0 ? <span>Buy Now</span> : <span>Place a bid</span>}
                          </div>
                          <div className="nft__item_like">
                              <i className="fa fa-heart"></i><span>50</span>
                          </div>                            
                      </div> 
                  </div>
              </div>                                         
      </div>


      </section>
        { openCollection &&
            <div className='checkoutNft'>
            <div className='maincheckout' style={{height: "85%"}}>
            <button className='btn-close' onClick={() => setOpenCollection(false)}>x</button>
                <div className='heading'>
                    <h3>Create a collection</h3>
                </div>
                        <h6>
                         Collection Image
                        </h6>
                      <div className="d-create-file">
                      <p key="{index}">PNG, JPG, GIF. Max 200mb. <br/>{fileNameCollection}</p><></>
                      {<p><img id="outputCollection" width="200" alt=""/></p>}
                      <div className='browse'>
                        <input type="button" id="get_file" className="btn-main" value="Browse"/>
                        <input id='upload_file' type="file" multiple onChange={onChangeCollection} />
                      </div>
                  </div>
                  <div className="spacer-20"></div>
                  <h6>
                         Collection Banner
                        </h6>
                  <div className="d-create-file">
                      <p key="{index}">PNG, JPG, GIF. Max 200mb. <br/>{fileNameCollectionBanner}</p><></>
                      {<p><img id="outputCollectionBanner" width="200" alt=""/></p>}
                      <div className='browse'>
                        <input type="button" id="get_file" className="btn-main" value="Browse"/>
                        <input id='upload_file' type="file" multiple onChange={onChangeCollectionBanner} />
                      </div>
                  </div>
                <div className='detailcheckout mt-4'>
                    <div className='listcheckout'>
                        <h6>
                         Name 
                        </h6>
                        <input type="text" id="name" className="form-control" placeholder="eg. Crypto Funks"/>
                    </div>
                </div>
                <div className='detailcheckout mt-4'>
                    <div className='listcheckout'>
                        <h6>
                         Ticker Symbol 
                        </h6>
                        <input type="text" id="ticker" className="form-control" placeholder="eg. CF"/>
                    </div>
                </div>
                <div className='detailcheckout mt-4'>
                    <div className='listcheckout'>
                        <h6>
                         Description 
                        </h6>
                        <input type="text" id="desc" className="form-control" placeholder="eg. This is my cool collection"/>
                    </div>
                </div>
                <h5>Category</h5>
                <div class="dropdown">
                  <input class="dropbtn" value={category}></input>
                  <div class="dropdown-content">
                    <button onClick={(e) => {e.preventDefault(); setCategory("Art")}}>Art <img width="25" src="./img/art.png" alt=""></img></button>
                    <button onClick={(e) => {e.preventDefault(); setCategory("Music")}}>Music <img width="25" src="./img/music.png" alt=""></img></button>
                    <button onClick={(e) => {e.preventDefault(); setCategory("Virtual World")}}>Virtual World <img width="25" src="./img/virt.png" alt=""></img></button>
                    <button onClick={(e) => {e.preventDefault(); setCategory("Collectible")}}>Collectible <img width="25" src="./img/coll.png" alt=""></img></button>
                  </div>
                </div>
                <button onClick={createCollection} id="createColl" className='btn-main lead mb-5'>Create</button>
                <p id="errorBid" style={{color: "red"}}></p>
            </div>
            </div>
        }
        { openCheckout &&
            <div className='checkout'>
                {!isActiveSale ? (!isActive ? <StepsMintAndList walletInit={walletInit} setCompose={setCompose}/> : <StepsLazyMintAndList walletInit={walletInit} setCompose={setCompose}/>) : (!isActive ? <StepsMint walletInit={walletInit} setCompose={setCompose}/> : <StepsLazyMint walletInit={walletInit} setCompose={setCompose}/>)}
                <button className='btn-close' onClick={() => setOpenCheckout(false)}>x</button>
            </div>
        }
        { wrongNetwork && isAuthenticated &&
            <div className='wrongnet'>
                <WrongNetwork signOut={signOut}/>
            </div>
        }
        { nftCreated && <div className='success'>
          {<SuccessfulCreation nftImage={URL.createObjectURL(file[0])} nftPreview={filePreview[0] ? URL.createObjectURL(filePreview[0]) : null} nftName={document.getElementById("item_title").value} nftLink={`/token/${activeCollection}:${tokenId}`} nftExtension={fileType[0]}/>}
        </div> }
      </div>
   );
}

export default Createpage;